<div class="">
  <div *ngFor="let review of reviews" class="border-bottom review-item">
    <ng-template [ngTemplateOutlet]="reviewItem" [ngTemplateOutletContext]="{ review: review }"></ng-template>
  </div>
  <ng-container *ngIf="!pager; else pagerTmpl">
    <app-loading-section *ngIf="isLoading"></app-loading-section>
    <app-empty-table [type]="emptyType" *ngIf="!isLoading && !reviews?.length"></app-empty-table>
    <div *ngIf="!isLoading && totalCount > reviews.length" class="p-3 text-center">
      <a href="javascript:;" (click)="onLoadMore()"
        ><ng-container i18n>Load More</ng-container> ({{ totalCount - reviews.length }})</a
      >
    </div>
  </ng-container>
  <ng-template #pagerTmpl>
    <app-loading-section
      *ngIf="isLoading"
      class="position-absolute"
      style="top: 0; bottom: 0; right: 0; left: 0"
    ></app-loading-section>
    <app-empty-table [type]="emptyType" *ngIf="!reviews?.length"></app-empty-table>
    <mat-paginator2
      #paginator
      [length]="totalCount"
      *ngIf="totalCount > 0"
      (page)="onPageChange($event)"
      [pageSize]="10"
      [pageSizeOptions]="[10, 20, 50]"
      [showFirstLastButtons]="true"
    >
    </mat-paginator2>
  </ng-template>
</div>

<ng-template #reviewItem let-review="review">
  <div>
    <ng-template [ngTemplateOutlet]="reviewContent" [ngTemplateOutletContext]="{ review: review }"></ng-template>
    <div
      class="review-reply border-top"
      *ngIf="canSeeReply && review.response && !collapsedReviewIds.has(review.reviewId)"
    >
      <ng-template [ngTemplateOutlet]="reviewResponse" [ngTemplateOutletContext]="{ review: review }"></ng-template>
    </div>
  </div>
  <mat-form-field2 [showLabel]="false" class="m-3 ml-5" *ngIf="isReplyingReviewId === review.reviewId">
    <textarea
      matInput
      [formControl]="replyCtrl"
      i18n-placeholder
      placeholder="Write your response here..."
      cdkTextareaAutosize
    ></textarea>
    <button
      matSuffix
      type="button"
      class="btn btn-secondary-info"
      [disabled]="replyCtrl.invalid"
      (click)="onReply(replyCtrl, review)"
      style="margin-right: -0.75rem"
    >
      <i class="cs-icon cs-icon-send"></i> Send
    </button>
  </mat-form-field2>
</ng-template>

<ng-template #reviewContent let-review="review">
  <div class="d-flex align-items-center">
    <div class="d-flex p-3 pr-0 flex-fill">
      <div class="position-relative">
        <app-rental-image
          [rentalId]="review.rentalId"
          [size]="40"
          [circle]="true"
          [clickable]="true"
        ></app-rental-image>
        <app-avatar
          [text]="review.source"
          [image]="review.source | channelIcon"
          backgroundColor="white"
          [border]="1"
          borderColor="#D4DFE3"
          [size]="20"
          style="padding: 3px; right: -10px; top: 1rem"
          class="position-absolute"
        ></app-avatar>
      </div>
      <div class="ml-3 flex-fill">
        <div class="text-bold">
          <div class="d-flex">
            <app-rental-name [rentalId]="review.rentalId" [clickable]="true"></app-rental-name>
            <div class="text-light text-normal-bold" [ngClass]="repliable || canSeeReply ? 'ml-2' : 'ml-auto'">
              {{ review.submittedAt | epoch }}
            </div>
          </div>
          <app-rating
            [maxRating]="getMaxRating | call : review"
            [rating]="review.channelOverallRating"
            [showLevelColor]="true"
          ></app-rating>
        </div>
        <div>
          {{ review.text }}
        </div>
        <ng-container *ngIf="!!review.privateFeedback">
          <hr />
          <div>
            <span class="text-semi-bold"><ng-container i18n>Private Feedback</ng-container>:</span>
            {{ review.privateFeedback }}
          </div>
        </ng-container>
      </div>
    </div>
    <div class="mr-3 text-nowrap" *ngIf="repliable || canSeeReply">
      <a
        href="javascript:;"
        class="text-sm text-info"
        *ngIf="repliable && isReplyingReviewId != review.reviewId && (canReply | call : review)"
        (click)="isReplyingReviewId = review.reviewId"
      >
        <i class="far fa-plus"></i> <ng-container i18n>Add Review</ng-container>
      </a>
      <a
        href="javascript:;"
        class="text-sm text-primary"
        (click)="onCollapseReview(review)"
        *ngIf="canSeeReply && review.response"
      >
        <i class="far" [ngClass]="collapsedReviewIds.has(review.reviewId) ? 'fa-angle-down' : 'fa-angle-up'"></i>
        {{ collapsedReviewIds.has(review.reviewId) ? 'View Review' : 'Hide Review' }}
      </a>
      <a
        href="javascript:;"
        *ngIf="isReplyingReviewId === review.reviewId"
        class="text-danger text-semi-bold text-sm"
        (click)="isReplyingReviewId = null"
        i18n
        >Close</a
      >
    </div>
  </div>
</ng-template>

<ng-template #reviewResponse let-review="review">
  <div class="d-flex p-3 pl-5">
    <app-avatar class="rental-avatar" [text]="review.reviewee.name || review.reviewee.role || 'Unknown'" [size]="24">
    </app-avatar>
    <div class="ml-3">
      <div class="d-flex">
        <div class="text-info text-bold">
          {{ review.reviewee.name || review.reviewee.role || 'Unknown' | titleCase }}
        </div>
        <div class="ml-2 text-light">
          {{ review.response.respondedAt | epoch }}
        </div>
      </div>
      <div>
        {{ review.response?.text }}
      </div>
    </div>
  </div>
</ng-template>
